import environment from '../constants/environment';

import { trackEvent } from '../helpers';

const FIELDS_TO_CACHE = [
  'first_name',
  'email',
  'phone',
  'wedding_date',
  'date_flexible',
  'guests',
];
const CONTACT_FORM_DETAILS_KEY = 'contact-form-cache';
const MESSAGE_HISTORY_KEY = 'previously-contacted-vendor-messages';
const CONTACT_ENDPOINT = `${environment.apiURL}/vendor/contact/`;

const saveToMessageHistory = ({ vendorId, formData }) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const ls = window.localStorage.getItem(MESSAGE_HISTORY_KEY);
    const cache = ls ? JSON.parse(ls) : {};
    let thisVendor = cache[vendorId] || [];
    thisVendor.push({
      ...formData,
      date: new Date().toISOString(),
    });
    cache[vendorId] = thisVendor;

    const str = JSON.stringify(cache);
    window.localStorage.setItem(MESSAGE_HISTORY_KEY, str);
    return cache;
  }
};

const getMessageHistoryFromLocalStorage = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return {
      type: 'GET_PREVIOUSLY_CONTACTED_DATA',
      payload: [],
    };
  }
  const str = window.localStorage.getItem(MESSAGE_HISTORY_KEY);
  return str ? JSON.parse(str) : {};
};

export default {
  cacheContactFields: formData => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const originalValue =
        window.localStorage.getItem(CONTACT_FORM_DETAILS_KEY) || '{}';
      const originalJSON = JSON.parse(originalValue);
      let obj = {
        ...originalJSON,
      };
      Object.keys(formData).forEach(key => {
        if (FIELDS_TO_CACHE.includes(key)) {
          const value = formData[key];
          obj[key] = value;
        }
      });
      window.localStorage.setItem(
        CONTACT_FORM_DETAILS_KEY,
        JSON.stringify(obj)
      );
      return { type: 'GET_FORM_CONTACT_DETAILS', payload: obj };
    }
  },
  getFormContactDetails: () => {
    let json = {};
    if (typeof window !== 'undefined' && window.localStorage) {
      const str = window.localStorage.getItem(CONTACT_FORM_DETAILS_KEY);
      json = str ? JSON.parse(str) : {};
    }
    return { type: 'GET_FORM_CONTACT_DETAILS', payload: json };
  },
  showMessageBox: () => {
    return { type: 'SHOW_MESSAGE_BOX' };
  },
  setMessageBox: to => ({ type: 'SET_MESSAGE_BOX', to }),
  getMessageHistory: () => {
    const messageHistory = getMessageHistoryFromLocalStorage();
    return {
      type: 'GET_MESSAGE_HISTORY',
      messageHistory,
    };
  },
  sendEnquiry: ({
    vendorId,
    formData,
    location,
    userId = null,
    onSuccess = () => {},
    onError = () => {},
  }) => dispatch => {
    const endpoint = `${CONTACT_ENDPOINT}${vendorId}`;

    formData.coupleId = null; // Update this when we have auth. userId variable?
    formData.vendorId = vendorId;
    // Sender and Recipient roles are hardcoded until we have two way messaging
    formData.senderRole = 'couple';
    formData.recipientRole = 'vendor';

    dispatch({
      type: 'SEND_ENQUIRY_STARTED',
    });

    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify({
        ...formData,
        vendorId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => {
      const messageHistory = saveToMessageHistory({ vendorId, formData });
      if (!res.ok) {
        onError();
        return dispatch({
          type: 'SEND_ENQUIRY_FAILED',
        });
      }
      trackEvent({
        category: 'Conversion',
        event: 'send-enquiry',
        label: location,
        userId,
        vendorId,
      });
      onSuccess();
      return dispatch({
        type: 'SEND_ENQUIRY_COMPLETE',
        messageHistory,
      });
    });
  },
};
